import { combineEpics } from 'redux-observable';
import { closeSyntheticSymbolBeforeRemoveEpic } from './_epics/closeSyntheticSymbolBeforeRemove.epic';
import { handleSyntheticSymbolNotFoundEpic } from './_epics/handleSyntheticSymbolNotFound.epic';
import { reloadSyntheticSymbolListEpic } from './_epics/reloadSyntheticSymbolList.epic';
import { toggleViewSyntheticSymbolSidebarEpic } from './_epics/toggleViewSyntheticSymbolSidebar.epic';

export const controllerSymbolSyntheticEpic = combineEpics(
  closeSyntheticSymbolBeforeRemoveEpic,
  handleSyntheticSymbolNotFoundEpic,
  reloadSyntheticSymbolListEpic,
  toggleViewSyntheticSymbolSidebarEpic,
);
